export const NEW_PLANING_DATE_ID = -1;
